import CustomButton from "components/Atoms/CustomButton"
import StringInput from "components/Atoms/StringInput"
import { withFormController } from "components/Molecules/FormController"
import React from "react"
import { inr } from "utils/formatters.utils"
import SellableItemPreview from "./SellableItemPreview"
import StockSelector from "./StockSelector"
import useOrderIds from "./useOrderIds"

type OrderItemProps = {
  index?: number
  path?: any
  source?: any
  data?: any
  onRemove?: any
  distributionCentres?: number[]
}

export function getAvailableStock(stock: any, isConsolidated?: boolean) {
  const relatedOfferStock = stock?.relatedStock?.offerStockCount

  // If the order is consolidated show currentStockCount
  return isConsolidated
    ? stock?.currentStockCount
    : relatedOfferStock || stock?.offerStockCount || 0
}
const OrderItem = ({
  distributionCentres,
  index,
  path,
  source,
  data,
  onRemove,
}: OrderItemProps) => {
  const orders = useOrderIds()
  const orderItems = source?.orderItems
  const selectedStock = data?.sellableItemStock
  const selectedRelatedOfferStock = selectedStock?.relatedStock?.offerStockCount

  const sellableItem = selectedStock?.sellableItem || data?.sellableItem
  const isConsolidated = orders?.length > 0
  const quantity = +data?.quantity
  let intent = "none"

  if (quantity) {
    if (orders?.length > 0) {
      if (quantity > selectedStock?.currentStockCount) {
        intent = "danger"
      }
    } else if (
      selectedRelatedOfferStock
        ? quantity > selectedRelatedOfferStock
        : quantity > selectedStock?.offerStockCount
    ) {
      intent = "danger"
    }
  } else {
    intent = "danger"
  }

  return (
    <div className="od-order-item od-row">
      <div>{index + 1}</div>
      <div data-testid="sellable-item-dropdown">
        <SellableItemPreview id={sellableItem?.id} name={sellableItem?.name} />
        <StockSelector
          orderItems={orderItems}
          distributionCentres={distributionCentres}
          sellableItem={sellableItem}
          path={path}
          isConsolidated={isConsolidated}
        />
      </div>
      {orders?.length > 0 && <div>{inr(data?.sourceDcRate || 0)}</div>}
      <div>
        <span className="line-through" data-testid="old-rate-text">
          {selectedStock?.unitRate}
        </span>
        <span data-testid="current-rate-text">
          {inr(selectedStock?.discountedRate || 0)}
        </span>
      </div>
      <div>
        <StringInput
          min={1}
          fill={false}
          type="number"
          big={false}
          path={`${path}.quantity`}
          intent={intent}
          data-testid="quantity-input"
        />
        {orders?.length > 0 && data?.stockCount && data?.stockCount > 0 ? (
          <div className="text-xs vt-warning" data-testid="stock-count-warning">
            Includes {data?.stockCount} DC Stock Count
          </div>
        ) : null}
      </div>
      <div data-testid="total-item-cost-text">
        {inr(selectedStock?.discountedRate * data?.quantity || 0)}
      </div>
      <div data-testid="stock-text">
        {getAvailableStock(selectedStock, isConsolidated)} <small>Units</small>
      </div>
      <div>
        <CustomButton
          icon="trash"
          intent="danger"
          minimal
          data-testid="delete-item-button"
          onClick={e => onRemove("orderItems", index)}
        />
      </div>
    </div>
  )
}

export default withFormController(OrderItem)
